export const PROJECT_LIMITS = {
  // ProjectLimitsToasts elements
  WARNING_TOAST_CONTAINER: 'project-limits-warning-toast-container',
  ERROR_TOAST_CONTAINER: 'project-limits-error-toast-container',
  PASTE_ERROR_TOAST_CONTAINER: 'project-limits-paste-error-toast-container',
  CREATE_ERROR_TOAST_CONTAINER: 'project-limits-create-error-toast-container',
  WARNING_ICON: 'project-limits-warning-icon',
  ERROR_ICON: 'project-limits-error-icon',
  WARNING_TITLE: 'project-limits-warning-title',
  ERROR_TITLE: 'project-limits-error-title',
  PASTE_ERROR_TITLE: 'project-limits-paste-error-title',
  CREATE_ERROR_TITLE: 'project-limits-create-error-title',
  WARNING_MESSAGE: 'project-limits-warning-message',
  ERROR_MESSAGE: 'project-limits-error-message',
  PASTE_ERROR_MESSAGE: 'project-limits-paste-error-message',
  CREATE_ERROR_MESSAGE: 'project-limits-create-error-message'
} as const;
